import template from './material-type-and-series.jade';
import buildingMaterialType from './../../../enums/material-type-urban';
import { isValidEnum } from '../../../utils';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.materialTypeAndSeries', [])
    .directive('cianAfAboutBuildingMaterialTypeAndSeries', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(isSimpleFormEnabled, deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.ad.building = this.ad.building || {};

            this.materialTypes = buildingMaterialType;

            // удаляем невалидное значение, пришедшее из других категорий
            if (this.ad.building && !isValidEnum(this.materialTypes, this.ad.building.materialType))
                this.ad.building.materialType = undefined;

            this.seriesValidation = validation(this.form, 'buildingSeries', {
                maxlength: 'Максимум 15 символов',
            });

            this.isSimpleFormEnabled = isSimpleFormEnabled;
            this.getFieldTitle = () => {
                return isSimpleFormEnabled() ? 'Тип дома' : 'Тип и серия дома';
            };
        },
        controllerAs: 'materialTypeAndSeries',
        template,
    }))
    .name;
